import React, { Component } from "react";
import errorIcon from "../../../../images/404-Error-pana.svg";
import unauthorizedIcon from "../../../../images/403-Error-pana.png";

class Unauthorised extends Component {
  render() {
    return (
      <div className="template-flex">
        <div className="skill-home scrollable">
          {/* <div className="tp-title">
                        <h3>Unauthorised Access</h3>                        
                    </div> */}
          <div className="auth-block">
            <div className="auth-block-img">
              <img src={unauthorizedIcon} />
            </div>
            <h3>You are not authorized to view this Skill</h3>
            <button
              className="btn btn-primary"
              onClick={() => {
                window.location.href = "/dashboard/create";
              }}
            >
              Go to dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Unauthorised;
